/**
 * Serviço de Usuários CRM
 * Responsabilidade: Gerenciar operações de usuários do CRM
 */

import { supabase } from '../../lib/supabase';
import { CrmUser } from '../../types';
import { handleServiceError } from '../utils/serviceUtils';

/**
 * Busca usuários do CRM da organização especificada
 * @param organizationId - ID da organização para filtrar membros
 */
export const getCrmUsers = async (organizationId?: string): Promise<CrmUser[]> => {
    try {
        if (!organizationId) {
            console.warn('[getCrmUsers] No organizationId provided, returning empty array');
            return [];
        }

        // Reutilizar a lógica centralizada do organizationService
        // Isso garante consistência com a lista de membros exibida na tela de Equipe
        const { getOrganizationMembers } = await import('./organizationService');
        const members = await getOrganizationMembers(organizationId);

        return members.map(member => {
            const fullName = member.user?.full_name?.trim();
            const email = member.user?.email?.trim();
            const name =
                (fullName && fullName.toLowerCase() !== 'usuário' ? fullName : undefined)
                || (email && email !== 'Email desconhecido' ? email : undefined)
                || 'Sem nome';
            return {
                id: member.user_id,
                name,
                accessType: (member.role === 'admin' || member.role === 'owner') ? 'Administrador' : 'Atendente',
                lastAccess: '',
                avatar: null,
            };
        });
    } catch (error) {
        console.error('Error fetching users:', error);
        return [];
    }
};

/**
 * Deleta um usuário do CRM
 */
export const deleteCrmUser = async (userId: string): Promise<void> => {
    console.log('[DELETE USER] Tentando deletar usuário:', userId);

    try {
        const { data, error } = await supabase
            .from('profiles')
            .delete()
            .eq('id', userId)
            .select();

        console.log('[DELETE USER] Resultado:', { data, error });

        if (error) throw error;

        console.log('[DELETE USER] Usuário deletado com sucesso');
    } catch (error) {
        handleServiceError('deletar usuário', error);
    }
};
